import { SxProps } from '@mui/material';

import { CustomTableVariant } from '@/components/table/CustomTable.comp.tsx';

export const CustomTableListViewBoxStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const CustomTableViewWrapperStyles = {
  margin: 'auto',
  width: '100%',
};

export const CustomTableViewWrapperPaperStyles = (params: {
  size?: CustomTableVariant;
}): SxProps => ({
  padding: params.size === 'small' ? '20px' : '3% 50px',
});
